import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const InquiryChat = () => {
  const navigate = useNavigate();

  // Generate or retrieve Device ID (UUID) from localStorage
  const getDeviceId = () => {
    let deviceId = localStorage.getItem('dws_device_id');
    if (!deviceId) {
      deviceId = 'dev_' + crypto.randomUUID();
      localStorage.setItem('dws_device_id', deviceId);
    }
    return deviceId;
  };

  useEffect(() => {
    const initInquiry = async () => {
      try {
        const deviceId = getDeviceId();
        
        // Get client IP (secondary identifier)
        let clientIP = 'Unknown';
        try {
          const ipResponse = await fetch('https://api.ipify.org?format=json');
          const ipData = await ipResponse.json();
          clientIP = ipData.ip;
        } catch (err) {
          console.warn('Could not get IP:', err);
        }
        
        // Check if this device already has an inquiry session
        const checkResponse = await axios.post(`${API}/inquiry/check`, {
          ip_address: clientIP,
          device_id: deviceId
        });
        
        if (checkResponse.data.exists) {
          const { guest_name, guest_user_id, chat_room_id } = checkResponse.data;
          
          const session = {
            guest_name,
            guest_user_id,
            chat_room_id,
            ip_address: clientIP,
            device_id: deviceId,
            is_inquiry: true,
            is_returning: true
          };
          localStorage.setItem('inquiry_session', JSON.stringify(session));
        } else {
          const pendingSession = {
            ip_address: clientIP,
            device_id: deviceId,
            referrer: document.referrer || 'Direct',
            is_inquiry: true,
            is_pending: true
          };
          localStorage.setItem('inquiry_session', JSON.stringify(pendingSession));
        }
        
        navigate(`/customer-chat?type=inquiry`, { replace: true });
        
      } catch (error) {
        console.error('Failed to initialize inquiry:', error);
        // Even on error, redirect to chat - will handle error there
        const pendingSession = {
          ip_address: 'Unknown',
          referrer: document.referrer || 'Direct',
          is_inquiry: true,
          is_pending: true
        };
        localStorage.setItem('inquiry_session', JSON.stringify(pendingSession));
        navigate(`/customer-chat?type=inquiry`, { replace: true });
      }
    };
    
    // P21 — /inquiry-chat redirects into the customer chat with `replace: true`
    // (below), so the chat page has NOTHING behind it in history — the old
    // double-back guard was removed per feedback. Forcing a literal brand-new
    // browser tab isn't possible for a link the guest opens externally (from
    // WhatsApp) — the OS/host browser decides that — but `replace` gives the
    // same "nothing behind the chat" outcome.
    initInquiry();
  }, [navigate]);

  // Return empty/transparent div - instant redirect, no visible loading
  return (
    <div className="min-h-screen bg-gray-100" />
  );
};

export default InquiryChat;
